var status = {
  namespace: true,
  state: {
    isAxisTime: false // 是否需要底部时间轴

  },
  mutations: {
    UPDATE_BOOT_AXISTIME: function UPDATE_BOOT_AXISTIME(state, playload) {
      state.isAxisTime = !!playload;
    }
  },
  actions: {}
};
export default status;